/* Write here your custom javascript codes */

(function($) {

    //mini-menu rollover
    $("img.img-hover").hover(
        function() {
            $(this).data("img-original", $(this).attr("src"));
            $(this).attr("src", $(this).data("img-over"));
        }, function() {
            $(this).attr("src", $(this).data("img-original"));
        }
    );

})(jQuery);

(function($) {

    //toggle menu - menu/close
    $(".toggle-menu-img").toggle(
        function() {
            $(this).attr('src','/assets/img/binweevils/toggle-menu/close1.png');
            $(".toggle-menu").show('slow');
        },
        function() {
            $(this).attr('src','/assets/img/binweevils/toggle-menu/menu1.png');
            $(".toggle-menu").hide('slow');
        }
    );

})(jQuery);

function buyItemFromBlog(itemTypeID, storeName, colour, itemTypeIDfree, colourFree) {

    swal({
            title: "Confirm Purchase",
            text: "Are you sure you'd like to purchase this item?",
            type: "info",
            showCancelButton: true,
            cancelButtonText: "No",
            confirmButtonText: "Yes",
            closeOnConfirm: false,
            showLoaderOnConfirm: true
        },
        function () {
            $.ajax({
                url: 'https://web.archive.org/web/20161118130533/http://news.binweevils.com/ajax/buy-item-from-blog',
                method: "POST",
                data: {
                    itemTypeID: itemTypeID,
                    storeName: storeName,
                    colour: colour,
                    timer: 1900624,
                    hash: "3d69729e0f78b16bc9def85f0253dd3f",
                    itemTypeIDfree: itemTypeIDfree || "",
                    colourFree: colourFree || ""
                },
                success: function (data) {
                    handleResponseCode(data, itemTypeID, storeName, colour, itemTypeIDfree, colourFree);
                }
            });
        });

}

function buyItemFromBlogWithVoucher(itemTypeID, storeName, colour, itemTypeIDfree, colourFree, useVoucher) {

    $.ajax({
        url: 'https://web.archive.org/web/20161118130533/http://news.binweevils.com/ajax/buy-item-from-blog',
        method: "POST",
        data: {
            itemTypeID: itemTypeID,
            storeName: storeName,
            colour: colour,
            timer: 1900624,
            hash: "3d69729e0f78b16bc9def85f0253dd3f",
            itemTypeIDfree: itemTypeIDfree || "",
            colourFree: colourFree || "",
            useVoucher: useVoucher
        },
        success: function (data) {
            handleResponseCode(data, itemTypeID, storeName, colour, itemTypeIDfree, colourFree, useVoucher);
        }
    });
}

function handleResponseCode(data, itemTypeID, storeName, colour, itemTypeIDfree, colourFree, useVoucher) {
    if (data.responseCode == 1) { //success
        swal({
            title: "Success!",
            text: "You have successfully purchased this item!</br> Check your My Stuff Box.",
            type: "success",
            html: true
        });
        return;
    }
    if (data.responseCode == 3) { //cannot afford
        swal({
            title: "Uh-oh!",
            text: "Sorry, you cannot afford this item.",
            type: "warning",
            html: true
        });
        return;
    }
    if (data.responseCode == 4) { //no item found
        swal({
            title: "Uh-oh!",
            text: "The item you are trying to purchase is not available.",
            type: "error",
            html: true,
            closeOnConfirm: true
        });
        return;
    }
    if (data.responseCode == 7) { //tycoon only
        swal({
            title: "Uh-oh!",
            text: "Sorry, you need to be a Bin Tycoon Member</br> to purchase this item.",
            type: "error",
            html: true,
            closeOnConfirm: true
        });
        return;
    }
    if (data.responseCode == 8) { //need higher level
        swal({
            title: "Uh-oh!",
            text: "Sorry, your level is not high enough to make this purchase.",
            type: "error",
            html: true,
            closeOnConfirm: true
        });
        return;
    }
    if (data.responseCode == 9) { //not logged in
        haveToLogInToBuyItemFromBlog();
        return;
    }
    if (data.responseCode == 5) { //voucher is applicable and optional
        swal({
                title: "You have Dosh vouchers!",
                text: "You have earned <strong>"+data.voucher_dosh+" Dosh</strong> in vouchers!</br>Would you like to use it towards this purchase?",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#69b22c",
                confirmButtonText: "Yes",
                cancelButtonText: "No",
                closeOnConfirm: false,
                closeOnCancel: false,
                showLoaderOnConfirm: true,
                html: true
            },
            function(isConfirm){
                if (isConfirm) {
                    buyItemFromBlogWithVoucher(itemTypeID, storeName, colour, itemTypeIDfree, colourFree, 1);
                } else {
                    buyItemFromBlogWithVoucher(itemTypeID, storeName, colour, itemTypeIDfree, colourFree, 0);
                }
            });
        return;
    }
    if (data.responseCode == 6) { //voucher is applicable and necessary
        swal({
                title: "You have Dosh vouchers!",
                text: "You do not have enough Dosh.</br>However, you have earned <strong>"+data.voucher_dosh+" Dosh</strong> in vouchers!</br>Would you like to use it towards this purchase?",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#69b22c",
                confirmButtonText: "Yes",
                cancelButtonText: "No",
                closeOnConfirm: false,
                closeOnCancel: false,
                showLoaderOnConfirm: true,
                html: true
            },
            function(isConfirm){
                if (isConfirm) {
                    buyItemFromBlogWithVoucher(itemTypeID, storeName, colour, itemTypeIDfree, colourFree, 1);
                } else {
                    swal("Cancelled", "Your purchase has been cancelled.", "warning");
                }
            });
        return;
    }
    swal({
        title: "Oops!</br>Something went wrong.",
        text: "There was an error while trying to purchase the item.",
        type: "error",
        html: true
    });
}

function incorrectUsernameOrPass() {
    swal({
        title: "Incorrect username or password",
        text: "Please try again",
        type: "error",
        html: true
    });
}

function parentDisabled() {
    swal({
        title: "Parent disabled",
        text: "Your account has been disabled by parent",
        type: "error",
        html: true
    });
}
